import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "field"]

  fill() {
    this.fieldTargets.forEach((input) => { input.value = this.sourceTarget.value })
  }
}
